module.exports = __webpack_public_path__ + "img/GrayDoubleArrowLeft.3df602f7.svg";